(ns ductile.ui.scene
  (:require [reagent.core :as r]))

(defonce registry (r/atom {}))

(defn ->kw-id [x]
  (cond
    (keyword? x) x
    (nil? x)     (keyword (gensym "scene-"))
    :else        (keyword (str x))))

(defn upsert-scene [scenes scene]
  (let [scenes (or scenes [])
        id     (:id scene)]
    (if (some #(= (:id %) id) scenes)
      ;; replace matching scene
      (mapv #(if (= (:id %) id) scene %) scenes)
      ;; otherwise append
      (conj scenes scene))))

(defn register-scene!
  "Register or replace a scene under the given ns. If a scene with the same
   :id already exists in that ns, it is replaced."
  [ns-name scene]
  (let [k      (keyword ns-name)
        scene' (-> scene
                   (update :id ->kw-id)
                   (assoc :ns ns-name))]
    (swap! registry update k (fnil upsert-scene []) scene')
    scene'))

(defn scenes-for [ns-name]
  (get @registry (keyword ns-name)))

(defn all-ns->scenes []
  @registry)

(defn scene-by-id [ns-name id]
  (let [id (->kw-id id)]
    (some #(when (= (:id %) id) %) (scenes-for ns-name))))
